<template>
  <div>
    <Head title="忘記密碼" />
    <form @submit.prevent="submit" autocomplete="off">
      <div
        class="
          flex flex-col
          sm:justify-center
          items-center
          max-w-md
          mx-auto
          my-16
          card
        "
      >
        <div class="w-full">
          <div class="mx-auto">
            <div class="title">重設您的密碼</div>
            <div class="content">
              透過「忘記密碼」功能所寄送的電子郵件中提供的重設密碼連結進入此頁面後，請於下方輸入您的電子郵件及新的密碼。
            </div>
            <div class="forgot_password_form_element">
              <div class="label">
                <label for="email">電子郵件</label>
              </div>
              <div class="input">
                <InputText id="email" type="text" v-model="form.email" />
                <div v-if="$page.props.errors.email" class="error_information">
                  <i class="pi pi-arrow-up" /> {{ $page.props.errors.email }}
                </div>
              </div>
            </div>
            <div class="forgot_password_form_element">
              <div class="label">
                <label for="password">密碼</label>
              </div>
              <div class="input">
                <Password
                  id="password"
                  v-model="form.password"
                  toggleMask
                  promptLabel="請輸入您的密碼"
                  weakLabel="弱"
                  mediumLabel="一般"
                  strongLabel="強"
                  :class="{ 'p-invalid': $page.props.errors.password }"
                />
                <div
                  v-if="$page.props.errors.password"
                  class="error_information"
                >
                  <i class="pi pi-arrow-up" /> {{ $page.props.errors.password }}
                </div>
              </div>
            </div>
            <div class="forgot_password_form_element">
              <div class="label">
                <label for="password_confirmation">確認密碼</label>
              </div>
              <div class="input">
                <Password
                  id="password_confirmation"
                  v-model="form.password_confirmation"
                  :feedback="false"
                  promptLabel="再次輸入您的密碼"
                  :class="{ 'p-invalid': $page.props.errors.password }"
                />
              </div>
            </div>
          </div>
        </div>
        <hr class="w-11/12 mx-auto text-fh-gray-light" />
        <div class="flex flex-col my-10 justify-center items-center">
          <div class="mt-5 text-center">
            <Button
              type="submit"
              label="重設密碼"
              icon="pi pi-key"
              iconPos="left"
              :disabled="!form.email"
              @click="submit"
            />
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import Layout from "@/Shared/Layout";
import InputText from "primevue/inputtext";
import Password from "primevue/password";
import Button from "primevue/button";

export default {
  layout: Layout,
  components: {
    InputText,
    Password,
    Button,
  },
  data() {
    return {
      form: {
        token: null,
        email: "",
        password: "",
        password_confirmation: "",
      },
    };
  },
  methods: {
    submit() {
      this.$inertia.post(route("password.update"), _.pickBy(this.form), {
        preserveScroll: true,
      });
    },
  },
  mounted() {
    this.form.token = this.$page.props.token;
    this.form.email = this.$page.props.request.email ?? "";
  },
};
</script>

<style lang="postcss">
.card {
  @apply border border-solid border-fh-gray-light;
}

.title {
  @apply text-center text-xl my-4;
}

.content {
  @apply m-4 text-sm;
}

.message {
  @apply text-center mt-4;
}

.forgot_password_form_element {
  @apply my-10 flex flex-row items-center;
}

.forgot_password_form_element .label {
  @apply text-right w-1/3 mr-5 text-sm;
}

.forgot_password_form_element .input {
  @apply text-left w-2/3;
}

.error_information {
  @apply text-red mt-1 pl-1;
}
</style>